import { render, staticRenderFns } from "./Lgx240444036513529856.vue?vue&type=template&id=6592a35b&scoped=true&"
import script from "./Lgx240444036513529856.vue?vue&type=script&lang=js&"
export * from "./Lgx240444036513529856.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592a35b",
  null
  
)

export default component.exports